import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Button, Paper } from '@mui/material';
import cx from 'classnames';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { appLayoutChange } from 'FRONTEND/actions/app';
import { doneExtending, extend, reduce } from 'FRONTEND/reducers/sidePanelSlice';
import useSize from 'FRONTEND/utils/hooks/useSize';
import {
  SCREEN_XS,
  SIDE_PANEL_AUTO_REDUCE_MAX_WIDTH,
  SPLIT_CONTENT_CONTAINER_ID,
} from 'LEGACY/constants';

const SidePanel = ({
  children,
}) => {
  const mainContainer = document.getElementsByClassName(SPLIT_CONTENT_CONTAINER_ID)?.[0]; // Container when sidepanel is present.
  const dispatch = useDispatch();
  const isSidePanelMounted = useSelector((state) => state.sidePanel.isMounted);
  const isExtended = useSelector((state) => state.sidePanel.isExtended);
  const isExtending = useSelector((state) => state.sidePanel.isExtending);
  const isSmall = useSelector((state) => state.app.isSmall);

  // Size & force-reduce triggering management
  const contentContainerWidth = useSize({ current: mainContainer });
  useEffect(() => {
    if (contentContainerWidth > 0 && isSidePanelMounted) {
      if (!isExtending) {
        setShouldForceReduce(contentContainerWidth < SIDE_PANEL_AUTO_REDUCE_MAX_WIDTH);
      } else {
        dispatch(doneExtending());
      }
      const newIsSmall = contentContainerWidth < SIDE_PANEL_AUTO_REDUCE_MAX_WIDTH;
      if (newIsSmall !== isSmall) {
        dispatch(appLayoutChange({ isSmall: newIsSmall }));
      }
    }
  }, [contentContainerWidth, isSidePanelMounted]);

  // Extend/reduce management
  const [shouldForceReduce, setShouldForceReduce] = useState(mainContainer?.clientWidth < SIDE_PANEL_AUTO_REDUCE_MAX_WIDTH);
  useEffect(() => {
    if (shouldForceReduce === true && isExtended && isSidePanelMounted) {
      dispatch(reduce());
    }
  }, [shouldForceReduce]);
  const handleLayoutToggleClick = () => {
    if (isExtended) {
      dispatch(reduce());
    } else {
      dispatch(extend());
    }
  };

  const sidePanelClasses = cx('sidePanel', {
    sidePanel_extended: isExtended,
    sidePanel_fixed: window.screen.width < SCREEN_XS,
  });

  return (
    <section className={sidePanelClasses}>
      <Paper className='sidePanel-surface' square elevation={3}>
        <div className='sidePanel-content'>
          {children}
        </div>
        <div className='sidePanel-layoutButton'>
          <Button
            onClick={handleLayoutToggleClick}
            fullWidth
            color='inherit'
          >
            {isExtended ? <KeyboardArrowLeftIcon /> : <KeyboardArrowRightIcon />}
          </Button>
        </div>
      </Paper>
    </section>
  );
};

export default SidePanel;
